import { VALIDATION_MESSAGE_MAPPER } from './validation-messages-mapper-token';
import { Component, Input, Inject, ChangeDetectionStrategy, Optional } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ValidationMessageMapperFn } from './validation-messages-map-fn';
import { Observable } from 'rxjs/Observable';
import { defaultValidationMessageMapper } from './validation-messages-map-fn';
import 'rxjs/add/operator/map';


export class ValidationMessagesComponent {
   control: FormControl | FormGroup;
  errorMessages$: Observable<string>;
  mapper: ValidationMessageMapperFn;

  constructor(
      mapper: ValidationMessageMapperFn
  ) {
    this.mapper = mapper ? mapper : defaultValidationMessageMapper;
  }

  ngOnInit() {
    this.errorMessages$ = this.control.statusChanges
      .map((status: string) => {
        if (this.control.dirty && status === 'INVALID' && this.control.errors) {
          // since it's invalid we assume that it has at least 1 error in the `this.group.errors` object
          let errorKeys = Object.keys(this.control.errors || {});
          return this.mapper(errorKeys[0], this.control.errors[errorKeys[0]]);
        }
        return null;
      });
  }

  ngAfterViewInit() {
    // run the update so that the observable emits the inital value
    this.control.updateValueAndValidity();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'av-validation-messages',
  template: `<span>{{errorMessages$ | async}}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [VALIDATION_MESSAGE_MAPPER, ] }, { type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'control': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
